<template>
    <div class="tpl-page-container">
        <SideBar></SideBar>
        <div>
            <Mainboard></Mainboard>
        </div>
    </div>
</template>

<script type="text/javascript">
import Mainboard from '@/components/dashboard_page/dashboard.vue'
import SideBar from '@/components/common_components/side_bar/side_menu.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        Mainboard,
        SideBar,
    },
    methods: {
        ...mapActions({
            change_index_content: 'dashboard/change_index_content',
            change_dashboard_content: 'dashboard/change_dashboard_content'
        })
    },
    watch: {
        '$route': function () {
            this.change_dashboard_content(this.$route.query)
        }
    },
    mounted: function () {
        this.change_index_content()
    }
}
</script>
<style type="text/css">
</style>
